import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

const OrdersSummary = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const orders = location.state?.orders || [];

  const goToOrder = (orderId) => {
    navigate(`/order/${orderId}`);
  };

  if (!orders.length) {
    return (
      <Container className="py-4">
        <h3>Orders Summary</h3>
        <p>No orders found.</p>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <h3 className="mb-4">🧾 Orders Summary</h3>
      <Row xs={1} md={2} lg={3} className="g-4">
        {orders.map((order) => (
          <Col key={order._id}>
            <Card className="shadow-sm h-100">
              <Card.Body>
                <Card.Title>
                  Order #{order._id.slice(-6)}
                </Card.Title>
                <Card.Text>
                  <strong>Vendor:</strong>{' '}
                  {typeof order.vendorId === 'object'
                    ? order.vendorId.name || order.vendorId._id
                    : order.vendorId}
                </Card.Text>
                <Card.Text>
                  <strong>Total:</strong> ₹{order.totalAmount?.toFixed(2)}
                </Card.Text>
                <Card.Text>
                  <strong>Status:</strong>{' '}
                  <span
                    className={
                      order.status === 'Delivered' ? 'text-success' : 'text-warning'
                    }
                  >
                    {order.status}
                  </span>
                </Card.Text>
                <Button
                  variant="primary"
                  onClick={() => goToOrder(order._id)}
                >
                  View Order
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default OrdersSummary;
